const es = {
  common: {
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    phone: 'Teléfono',
    email: 'Email',
    office: 'Oficina',
    availability: 'Disponibilidad',
    support: 'Soporte',
    preOrder: 'Prepedido',
    clearForm: 'Limpiar formulario',
    sending: 'Enviando...',
    select: 'Seleccionar',
    closeNotification: 'Cerrar notificación',
  },
  nav: {
    home: 'Inicio',
    about: 'Sobre nosotros',
    preOrder: 'Prepedido',
    contacts: 'Contactos',
    startPreOrder: 'Iniciar prepedido',
    openMenu: 'Abrir menú',
    closeMenu: 'Cerrar menú',
    logoAria: 'Inicio de KUB AUTO',
    languageSwitcher: 'Idioma',
  },
  seo: {
    defaultTitle: 'KUB AUTO — Prepedido de vehículos premium en toda Europa',
    defaultDescription: 'Selección, verificación, compra y entrega de vehículos premium en toda Europa con condiciones fijas y seguridad legal.',
    home: {
      title: 'KUB AUTO — Prepedido de vehículos premium en toda Europa',
      description: 'Selección, verificación, compra y entrega de vehículos premium en toda Europa con condiciones fijas y seguridad legal.',
    },
    about: {
      title: 'Sobre KUB AUTO — servicio de adquisición de vehículos premium',
      description: 'Descubre cómo KUB AUTO organiza la búsqueda, verificación, contratación, logística y entrega de vehículos premium en toda Europa.',
    },
    preOrder: {
      title: 'Formulario de prepedido — envía los requisitos del vehículo | KUB AUTO',
      description: 'Envía tus requisitos para un vehículo premium y recibe opciones verificadas, condiciones claras y un proceso basado en contrato.',
    },
    contacts: {
      title: 'Contactos — concierge de KUB AUTO',
      description: 'Contacta con KUB AUTO vía WhatsApp, Telegram o email para consultas sobre vehículos premium y solicitudes de prepedido.',
    },
  },
  home: {
    gallery: {
      kicker: 'VEHÍCULOS SELECCIONADOS',
      title: 'Coches premium reales de adquisiciones recientes',
      sub: 'Una selección de vehículos reales que hemos adquirido y entregado recientemente. Cada coche refleja nuestros estándares de calidad, verificación y servicio.',
    },
    hero: {
      kicker: 'SERVICIO PRIVADO DE ADQUISICIÓN',
      title: 'Vehículos premium por prepedido individual',
      lead: 'Selección, verificación, compra y entrega en toda Europa — con condiciones fijas y seguridad legal.',
      cta: 'Iniciar prepedido',
      pills: ['Basado en contrato', 'Bases de datos oficiales', 'Soporte integral'],
      cardTitle: 'Lo que obtienes',
      badge: 'ESTÁNDAR',
      bullets: [
        'Proceso documentado y tarifas fijas',
        'Controles técnicos y legales antes de la compra',
        'Logística, aduanas, certificación y entrega',
      ],
    },
    process: {
      title: 'El proceso',
      sub: 'Claro, documentado y predecible.',
      steps: [
        { title: 'Solicitud', sub: 'Requisitos' },
        { title: 'Análisis de mercado', sub: 'Fuentes verificadas' },
        { title: 'Verificación', sub: 'Legal + técnica' },
        { title: 'Contrato', sub: 'Condiciones fijas' },
        { title: 'Entrega', sub: 'Recepción' },
      ],
      ctaTitle: 'Envía tus requisitos — volveremos con opciones verificadas',
      ctaText: 'El tiempo típico de búsqueda es de unos días hasta dos semanas.',
      cta: 'Iniciar prepedido',
    },
    trust: {
      title: 'Por qué los clientes confían en nosotros',
      sub: 'Transparencia + seguridad legal durante toda la transacción.',
      cards: [
        { title: 'Contrato formal', text: 'Tarifas, etapas y plazos fijados.' },
        { title: 'Verificación', text: 'Bases de datos oficiales + informes.' },
        { title: 'Servicio integral', text: 'Logística, aduanas, certificación.' },
      ],
      missionTitle: 'Procedimiento regulado',
      missionText: 'Selección → verificación → acuerdo → contrato → compra → entrega → recepción. Cada etapa se documenta.',
      cta: 'Obtener una consulta',
    },
    reviewsFaq: {
      reviewsTitle: 'Opiniones de clientes',
      reviewsSub: 'Comentarios breves de clientes que valoran la previsibilidad, la claridad y el control.',
      reviews: [
        {
          quote: '“Todo coincidió exactamente con lo que acordamos.”',
          text: 'Pasos claros, actualizaciones regulares y ninguna presión. El precio y el plazo se mantuvieron como se había hablado, y la entrega fue fluida.',
          meta: 'Andrius Kazlauskas, Vilnius (LT)',
        },
        {
          quote: '“Sabía lo que estaba pasando en cada etapa.”',
          text: 'Enviaron opciones con todos los detalles, explicaron qué revisar y gestionaron la documentación correctamente. Sin llamadas innecesarias, solo comunicación clara.',
          meta: 'Nerijus Šimkus, Kaunas (LT)',
        },
        {
          quote: '“El coche llegó exactamente como se describió.”',
          text: 'Los resultados de la inspección se compartieron de antemano, la logística se organizó sin retrasos y los documentos estuvieron listos a tiempo. En general: un proceso profesional y tranquilo.',
          meta: 'Mārtiņš Pētersons, Riga (LV)',
        },
      ],
      faqTitle: 'FAQ',
      faqSub: 'Respuestas a las preguntas más frecuentes sobre el proceso.',
      faq: [
        { q: '¿Cómo empiezo un prepedido?', a: 'Envía un formulario de prepedido con tus requisitos. Confirmamos los detalles y comenzamos la búsqueda.' },
        { q: '¿Cuánto tarda la selección del vehículo?', a: 'Normalmente de unos días a dos semanas, según la complejidad de los requisitos.' },
        { q: '¿Cómo se verifican los vehículos?', a: 'Cada vehículo se somete a una verificación técnica y legal mediante bases de datos oficiales e informes de inspección.' },
        { q: '¿Cuándo se firma el contrato?', a: 'Después de que apruebes un vehículo concreto y se acuerden todas las condiciones.' },
        { q: '¿Qué costes se fijan por adelantado?', a: 'La tarifa del servicio, la logística, el despacho aduanero y los cargos obligatorios se fijan en el contrato.' },
        { q: '¿Qué sucede después de comprar el vehículo?', a: 'Organizamos la logística, el despacho aduanero, la certificación y la preparación para la entrega.' },
        { q: '¿Cuándo recibiré el vehículo?', a: 'Una vez completados todos los procedimientos y verificados los documentos, el vehículo se te entrega.' },
        { q: '¿Puedo rechazar un vehículo seleccionado?', a: 'Sí. La búsqueda continúa hasta que se aprueba un vehículo que cumpla plenamente tus requisitos.' },
        { q: '¿Trabajan con empresas además de clientes privados?', a: 'Sí. Trabajamos tanto con particulares como con entidades jurídicas bajo contrato formal.' },
        { q: '¿En qué países buscan vehículos?', a: 'Buscamos vehículos en toda Europa, trabajando solo con proveedores y plataformas de subastas verificadas.' },
        { q: '¿Está incluida la entrega y el despacho aduanero?', a: 'Sí. La logística completa, el despacho aduanero y la certificación forman parte de nuestro servicio.' },
      ],
    },
    finalCta: {
      kicker: 'LISTO PARA EMPEZAR',
      title: 'Inicia tu solicitud de prepedido',
      sub: 'Responderemos con opciones verificadas y condiciones claras.',
      cta: 'Ir al prepedido',
    },
  },
  about: {
    hero: {
      kicker: 'SOBRE LA EMPRESA',
      title: 'Vehículos premium adquiridos mediante prepedido individual en toda Europa',
      lead: 'Ofrecemos selección, verificación y adquisición profesional de vehículos premium según las solicitudes individuales del cliente, con soporte legal y logístico completo desde la búsqueda inicial hasta la entrega final.',
      cta: 'Enviar solicitud de prepedido',
    },
    overview: {
      title: 'Visión general',
      sub: 'Nuestros servicios están diseñados para clientes que valoran la transparencia, los procesos estructurados y la seguridad legal.',
      cards: [
        {
          title: 'Ámbito de actividad',
          text: 'La empresa está especializada en la búsqueda, verificación y compra de vehículos premium en el mercado europeo, incluidos concesionarios oficiales, proveedores verificados y plataformas de subastas. Todas las etapas — desde la selección inicial hasta la entrega del vehículo — se realizan de acuerdo con un estándar de calidad unificado y plazos acordados.',
        },
        {
          title: 'Soporte integral',
          text: 'Proporcionamos selección del vehículo en base a parámetros definidos, verificación técnica y legal documentada, fijación del alcance y del precio en un contrato, organización de la compra, logística, despacho aduanero, certificación y preparación del vehículo para la entrega final.',
        },
      ],
    },
    principles: {
      title: 'Principios de trabajo',
      sub: 'Un proceso estructurado y documentado con responsabilidad clara en cada etapa.',
      cards: [
        { icon: '✓', title: 'Formalidad y transparencia', text: 'Todas las etapas de la cooperación y las tarifas del servicio se fijan en un contrato. El cliente tiene total claridad sobre el proceso, los plazos y las obligaciones de cada parte.' },
        { icon: '🧾', title: 'Verificación integral del vehículo', text: 'Cada vehículo se somete a verificación técnica y legal utilizando bases de datos oficiales, historial de servicio y, cuando sea necesario, inspección independiente de expertos.' },
        { icon: '🎯', title: 'Enfoque individual', text: 'La selección del vehículo se realiza estrictamente de acuerdo con el presupuesto, las preferencias y el uso previsto por el cliente — sin ofertas aleatorias o inadecuadas.' },
        { icon: '🛡', title: 'Soporte completo', text: 'Organizamos la compra, la logística, el despacho aduanero, la certificación y la preparación del vehículo para la entrega, minimizando los riesgos y la implicación del cliente.' },
      ],
    },
    advantages: {
      title: 'Ventajas clave',
      sub: 'Por qué los clientes eligen un formato de prepedido individual con soporte profesional.',
      items: [
        'Experiencia comprobada en el segmento automotriz premium',
        'Cooperación exclusiva con proveedores y plataformas de subastas verificadas',
        'Flujo de trabajo claramente estructurado y estricto cumplimiento de los plazos acordados',
        'Responsabilidad por los resultados en cada etapa de la transacción',
      ],
    },
    mission: {
      kicker: 'MISIÓN',
      title: 'Proporcionar acceso a vehículos premium con calidad garantizada y seguridad legal.',
      text: 'Ofrecemos un servicio estructurado, transparente y profesional en cada etapa — desde la selección inicial hasta la entrega final del vehículo con documentación completa.',
      ctaPrimary: 'Enviar solicitud de prepedido',
      ctaSecondary: 'Contactarnos',
    },
    process: {
      title: 'Cómo funciona el proceso de prepedido',
      sub: 'Un procedimiento secuencial con etapas definidas y puntos de control.',
      steps: [
        { num: '01', title: 'Solicitud', text: 'Envías los parámetros del vehículo y tus requisitos individuales.' },
        { num: '02', title: 'Selección', text: 'Buscamos y presentamos opciones verificadas que coinciden con tus criterios.' },
        { num: '03', title: 'Contrato', text: 'Todas las condiciones, etapas y tarifas del servicio se fijan contractualmente.' },
        { num: '04', title: 'Compra y logística', text: 'Organizamos la compra, la entrega, el despacho aduanero y la certificación.' },
        { num: '05', title: 'Entrega', text: 'El vehículo se prepara y se entrega con un conjunto completo de documentos.' },
      ],
      ctaPrimary: 'Enviar solicitud de prepedido',
      ctaSecondary: 'Hacer una pregunta en Telegram',
    },
  },
  contacts: {
    hero: {
      kicker: 'CONTACTOS',
      title: 'Ponte en contacto',
      lead: 'La vía más rápida: WhatsApp. Estamos disponibles 24/7 para consultas y solicitudes de prepedido.',
    },
    primary: {
      title: 'KUB AUTO Concierge',
      emailUs: 'Envíanos un email',
      telegramCta: '¿Prefieres Telegram? Abrir chat →',
    },
    office: {
      label: 'Dirección de la oficina',
      address: 'Dzūkų g. 6a, Vilnius, 02163 Vilniaus m. sav.',
      badge: '24/7',
      hoursLabel: 'Horario laboral',
      hoursValue: '24/7',
      supportLabel: 'Soporte',
      supportValue: 'WhatsApp / Email',
      preOrderLabel: 'Prepedido',
      preOrderValue: 'Proceso basado en contrato',
      openMaps: 'Abrir en Google Maps',
      mapTitle: 'Mapa de la oficina de KUB AUTO',
    },
    form: {
      title: 'Mensaje rápido',
      sub: 'Deja una nota breve — responderemos lo antes posible.',
      nameLabel: 'Tu nombre',
      namePlaceholder: 'Nombre completo',
      emailLabel: 'Email',
      emailPlaceholder: 'name@example.com',
      messageLabel: 'Mensaje',
      messagePlaceholder: '¿Qué coche estás buscando? Presupuesto, año, kilometraje, preferencias...',
      submit: 'Enviar mensaje',
      success: 'Mensaje enviado correctamente. Te responderemos pronto.',
      error: 'No se pudo enviar el mensaje.',
    },
  },
  preOrder: {
    hero: {
      kicker: 'FORMULARIO DE PREPEDIDO',
      title: 'Envía los requisitos del vehículo',
      lead: 'Revisaremos tu solicitud y responderemos con opciones verificadas y condiciones claras.',
    },
    vehicle: {
      title: 'Detalles del vehículo',
      sub: 'Parámetros principales para comenzar la selección.',
      make: 'Marca',
      makePlaceholder: 'p. ej. BMW',
      model: 'Modelo',
      modelPlaceholder: 'p. ej. X5',
      year: 'Año',
      yearPlaceholder: 'p. ej. 2020',
      mileage: 'Kilometraje (km)',
      mileagePlaceholder: 'p. ej. 45000',
      fuelType: 'Tipo de combustible',
      bodyType: 'Tipo de carrocería',
      preferences: 'Preferencias adicionales',
      preferencesPlaceholder: 'Acabado, color, interior, estado, historial de uso, requisitos especiales...',
      fuelOptions: [
        { value: 'petrol', label: 'Gasolina' },
        { value: 'diesel', label: 'Diésel' },
        { value: 'hybrid', label: 'Híbrido' },
        { value: 'electric', label: 'Eléctrico' },
      ],
      bodyOptions: [
        { value: 'sedan', label: 'Sedán' },
        { value: 'wagon', label: 'Familiar' },
        { value: 'coupe', label: 'Coupé' },
        { value: 'suv', label: 'SUV' },
        { value: 'hatchback', label: 'Hatchback' },
        { value: 'other', label: 'Otro' },
      ],
    },
    buyer: {
      title: 'Información del comprador',
      sub: 'Para contrato y comunicación.',
      buyerType: 'Tipo de comprador',
      buyerTypeOptions: [
        { value: 'individual', label: 'Particular' },
        { value: 'company', label: 'Empresa' },
      ],
      buyerName: 'Nombre / Empresa',
      buyerNamePlaceholder: 'Nombre completo o entidad jurídica',
      address: 'Dirección',
      addressPlaceholder: 'Calle, ciudad, país',
      phone: 'Teléfono',
      phonePlaceholder: '+370 688 03122',
      email: 'Email',
      emailPlaceholder: 'name@example.com',
      submit: 'Enviar solicitud',
      askWhatsapp: 'Preguntar en WhatsApp',
      askTelegram: 'Preguntar en Telegram',
      success: 'Solicitud enviada correctamente. Nos pondremos en contacto contigo en breve.',
      error: 'No se pudo enviar la solicitud.',
    },
    validation: {
      required: 'Obligatorio',
      yearFormat: 'Usa 4 dígitos (p. ej. 2020)',
      numbersOnly: 'Solo números',
      tooLong: 'Demasiado largo',
      invalidPhone: 'Usa formato internacional, p. ej. +37068803122',
      invalidEmail: 'Email no válido',
      invalid: 'No válido',
    },
  },
  validation: {
    tooShort: 'Demasiado corto',
    tooLong: 'Demasiado largo',
    required: 'Obligatorio',
    invalidEmail: 'Email no válido',
    invalid: 'No válido',
    unknownError: 'Error desconocido',
  },
};

export default es;
